module.exports = __webpack_public_path__ + "static/img/part1.b89c10f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/KOF14/bottom/part1/part1.jpg
// module id = UwE/
// module chunks = 0